<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Max number of rows for this field']"
    >
    <mat-icon fontSet="material-icons-outlined" title="Max number of rows">table_rows</mat-icon>
    <h3>
      Max number of rows
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>Change the maximum number of rows displayed</p></td>
      </tr>
      <tr>
        <td>
          <span class="input-container">
            <input [(ngModel)]="limit" type="number" placeholder="e.g. 5" title="Enter limit" min="0" (input)="updateParent()" />
          </span>
        </td>
      </tr>
    </table>
  }
</section>
